//import './index.scss';

let serpStateElements = null;
let serpState = null;

const STATES = {
    INIT: 0,
    LOADING: 1,
    READY: 2,
    ERROR: 4
};

const INTERNAL_ERROR_MSG = '';
const PROVIDER_ERROR_MSG = 'We are having trouble with our search provider. Please try your search again now -- just click the search button above.';
const NO_RESULT_MSG = 'PCH Search &amp; Win did not find anything for <i>{searchTerm}</i>';

class SerpStateElements {
    constructor(parent, config) {
        if(!serpStateElements) {
            this.config = config;
            this.parent = parent;
            this.parent.style.position = 'relative';
            this.details = null;

            serpStateElements = this;
        }

        return serpStateElements;
    }


    injectLoader() {
        const loaderElement = document.createElement('div');
        loaderElement.classList.add('serp-state', 'serp-state--loading');

        const indicator = document.createElement('img');
        indicator.src = '/images/circle_loader.gif';
        indicator.classList.add('serp-state__indicator');

        loaderElement.appendChild(indicator);

        this.parent.appendChild(loaderElement);

        this.loaderElement = loaderElement;
        
    }

    removeLoader() {
        this.parent.removeChild(this.loaderElement);
    }

    injectError() {
        const errorElement = document.createElement('div');
        errorElement.classList.add('serp-state', 'serp-state--error');

        const indicator = document.createElement('span');
        indicator.classList.add('serp-state__indicator');

        if(this.config.errorCode) {
            indicator.innerHTML = this.config.errorMessage || INTERNAL_ERROR_MSG;
        } else if(this.details && (this.details.status || this.details.message)) {
            indicator.innerHTML = this.config.failureText || PROVIDER_ERROR_MSG;
        } else {
            let msg = this.config.notFoundText || NO_RESULT_MSG;
            indicator.innerHTML = msg.replace('{searchTerm}', this.config.queryTerms);
        }

        //(this.details.maxAlgoResultCount === 0 || typeof this.details.maxAlgoResultCount === 'undefined')

        errorElement.appendChild(indicator);

        this.parent.appendChild(errorElement);

    }
}

class SerpState {

    constructor(parent, config, ui) {

        if(!serpState) {
            serpStateElements = new ui(parent, config);

            this.currentState = STATES.INIT;

            serpState = this;
        }

        return serpState;
    }


    set state(state) {
        switch(state) {
        case STATES.INIT: 
            break;
        case STATES.LOADING:
            serpStateElements.injectLoader();
            break;
        case STATES.READY:
            serpStateElements.removeLoader();
            break;
        case STATES.ERROR:
            serpStateElements.injectError();
            break;
        default:
                //Invalid State
        }

        this.currentState = state;
    }

    get state() {
        return this.currentState;
    }

    loading() {
        if(serpState.state === STATES.INIT) {
            serpState.state = STATES.LOADING;
        }

    }

    ready(details) {
        serpStateElements.details = details;
        if(serpState.state === STATES.LOADING) {
            serpState.state = STATES.READY;
        }
    }

    error(details) {
        serpStateElements.details = details;
        if(serpState.state === STATES.LOADING) {
            serpState.state = STATES.ERROR;
        }

    }
}

export {SerpState as default, SerpStateElements};